import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { Header } from "./Header";
import { Footer } from "./Footer";

const Loader = () => (
  <motion.div
    initial={{ opacity: 1 }}
    exit={{ y: "-100%" }}
    transition={{ duration: 1, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
    className="fixed inset-0 z-[100] bg-ink flex items-center justify-center"
    data-testid="loader"
  >
    <div className="overflow-hidden">
      <motion.img
        src="/nk-logo-light.png"
        alt="NK Bridal"
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="h-24 md:h-36 w-auto"
      />
    </div>
  </motion.div>
);

export const Layout = () => {
  const [loading, setLoading] = useState(true);
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduce) {
      const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
      lenisRef.current = lenis;
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
    const t = setTimeout(() => setLoading(false), 1400);
    return () => { clearTimeout(t); lenisRef.current?.destroy(); };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App grain bg-ivory text-ink min-h-screen flex flex-col">
      <Toaster position="bottom-right" theme="light" />
      <AnimatePresence>{loading && <Loader />}</AnimatePresence>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
